// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_zfQ","cls2":"MarketingPageLayout-cls2_kmu MarketingPageLayout-cls1_zfQ"};